import PropTypes from 'prop-types';

import { dateUtils } from '~/routes/utils';
import { isBoolean } from '~/utils';
import { questionHelpers } from '~/components';
import { formatAnswersHelpers } from './format-answers.helpers';

export const sortMultipleAnswers = (options, answers) => {
  if (options) {
    const optionsArray = options.map((option) => option.displayName);
    return answers.sort((a, b) => optionsArray.indexOf(a) - optionsArray.indexOf(b));
  }
  return answers;
};

function isNotEmptyAnswerTypeArray(answer) {
  return answer.length !== 0 && answer.every((elem) => elem !== '');
}

function isNotEmptyAnswerTypeObject(answer) {
  return answer ? Object.values(answer).join('') !== '' : false;
}

export const isNotEmptyAnswer = (answer) =>
  Array.isArray(answer) ? isNotEmptyAnswerTypeArray(answer) : isNotEmptyAnswerTypeObject(answer);

export const isCheckboxAnswerNotEmpty = (answer) => isBoolean(answer) && answer;

const createParagraph = (text) => <p className="sessioncamhidetext">{text}</p>;

export const formatArrayAnswer = ({ answer }) =>
  isNotEmptyAnswer(answer) ? createParagraph(answer.sort((a, b) => a - b).join(', ')) : null;

export const formatAnswer = ({ answer }) =>
  isNotEmptyAnswer(answer) ? createParagraph(answer) : null;

export const formatBooleanAnswer = ({ answer: rawAnswer }) => {
  const answer = Array.isArray(rawAnswer) ? rawAnswer[0] : rawAnswer;
  return answer ? createParagraph('Yes') : createParagraph('No');
};

export const formatHeightAnswer = ({ answer }) => {
  const values = [];
  if (answer && answer.feet) values.push(`${answer.feet} feet`);
  if (answer && answer.inches) values.push(`${answer.inches} inches`);
  if (answer && answer.cm) values.push(`${answer.cm} cm`);
  return isNotEmptyAnswer(answer) ? createParagraph(values.join(', ')) : null;
};

export const formatDropdownCheckboxAnswer = ({ answer: rawValue }) => {
  const value = rawValue && rawValue[0];

  return isBoolean(value) ? formatBooleanAnswer({ answer: value }) : null;
};

export const formatDateAnswer = ({ answer }) =>
  isNotEmptyAnswer(answer)
    ? createParagraph(dateUtils.getUKFormattedDate(formatAnswersHelpers.getAnswer(answer)))
    : null;

const getColourAnswerText = ({ displayName }) => <p>{displayName}</p>;

export const formatArrayWithColourAnswer =
  (options) =>
  ({ answer: rawAnswer }) => {
    if (!rawAnswer || !isNotEmptyAnswer(rawAnswer)) {
      return null;
    }

    const [answer] = rawAnswer;

    return getColourAnswerText(options.find((el) => questionHelpers.composeAnswer(el) === answer));
  };

export const formatPrice = ({ answer, question }) =>
  answer ? createParagraph(question.title || question.label) : null;

formatArrayAnswer.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
};

formatAnswer.propTypes = {
  answer: PropTypes.string.isRequired,
};

formatHeightAnswer.propTypes = {
  answer: PropTypes.shape({
    feet: PropTypes.number,
    inches: PropTypes.number,
    cm: PropTypes.number,
  }).isRequired,
};

formatDateAnswer.propTypes = {
  answer: PropTypes.string.isRequired,
};

getColourAnswerText.propTypes = {
  displayName: PropTypes.string.isRequired,
};

formatBooleanAnswer.propTypes = {
  answer: PropTypes.bool.isRequired,
};
